<template>
  <div @mouseenter="showTooltip" @mouseleave="hideTooltip" class="relative">
    <slot></slot>
    <div v-if="isTooltipVisible" class="custom-tooltip" :class="TooltipStyle">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from "vue-property-decorator";

 
@Component
export default class CustomTooltip extends Vue {
    @Prop() TooltipStyle;
  @Prop() contentStyle; 
 
  isTooltipVisible = false;

  showTooltip() {
    this.isTooltipVisible = true;
  }

  hideTooltip() {
    this.isTooltipVisible = false;
  }
}
</script>

<style scoped>
.custom-tooltip {
  position: absolute;
  border-radius: 8px;
  top: -73px; 
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
  right: 68px;
  width: 350px;
  height: auto;
  background: white;
  color: rgba(0, 0, 0, 0.88);
  padding: 4px;
  border-radius: 5px;
  z-index: 1;
  font-size: 16px;
  display: inline-block;
}
.tooltipResources{
  top: 18px !important;
  right: 15px;
}
.tooltipProjects{
  top: 20px !important;
  right: 4px;
}
.tooltipTasks{
  top:20px;
  right: 17px;

}
.tooltipTimeSheet {
  top:23px !important;
  right: 43px !important;
}
.actionLink:hover,
.actionLink:active {
  border-radius: 4px;
  background: #F9DB82;
  font-weight: 500;
}
.actionLink {
  width: 100%;
  color: rgba(0, 0, 0, 0.88);
  font-size: 16px;
  padding: 5px 12px 5px 12px;
  font-weight: 400;
  text-align: left;
}
</style>
